var _linearGradient, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath0, _clipPath1, _clipPath10, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroadlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 24,
    x2: 24,
    y1: 0,
    y2: 48
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20a4f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007fff"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 48,
    rx: 8,
    width: 48
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.7812 5.34375h2.8125v37.3125h-2.8125z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.375 1.03125h3.375v45.9375h-3.375z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m34.7812.84375h3.75v46.3125h-3.75z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.375.75h3.75v46.5h-3.75z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.1562.75h3.375v46.5h-3.375z"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.0312.9375h3v46.125h-3z"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.9062 1.03125h2.8125v45.9375h-2.8125z"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.7812 1.21875h2.4375v45.5625h-2.4375z"
  }))), _clipPath0 || (_clipPath0 = /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.0312 1.40625h2.0625v45.1875h-2.0625z"
  }))), _clipPath1 || (_clipPath1 = /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.71875 1.40625h2.0625v45.1875h-2.0625z"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.40625 5.71875h2.0625v36.5625h-2.0625z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#43b17e",
    height: 48,
    rx: 8,
    width: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.1875,
    cy: 41.25,
    opacity: 0.03,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.1875,
    cy: 36.9375,
    opacity: 0.03,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.1875,
    cy: 32.625,
    opacity: 0.03,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.1875,
    cy: 28.3125,
    opacity: 0.03,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.1875,
    cy: 24,
    opacity: 0.03,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.1875,
    cy: 19.6875,
    opacity: 0.03,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.1875,
    cy: 15.375,
    opacity: 0.03,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.1875,
    cy: 11.0625,
    opacity: 0.03,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.1875,
    cy: 6.75,
    opacity: 0.03,
    r: 1.40625
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 45.5625,
    opacity: 0.03,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 41.25,
    opacity: 0.03,
    r: 1.59375
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 36.9375,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 32.625,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 28.3125,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 24,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 19.6875,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 15.375,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 11.0625,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 6.75,
    opacity: 0.03,
    r: 1.59375
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0625,
    cy: 2.4375,
    opacity: 0.03,
    r: 1.40625
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 45.5625,
    opacity: 0.03,
    r: 1.59375
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 41.25,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 36.9375,
    opacity: 0.07,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 32.625,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 28.3125,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 24,
    opacity: 0.07,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 19.6875,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 15.375,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 11.0625,
    opacity: 0.05,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 6.75,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6562,
    cy: 2.4375,
    opacity: 0.03,
    r: 1.59375
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 45.5625,
    opacity: 0.03,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 41.25,
    opacity: 0.05,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 36.9375,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 32.625,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 28.3125,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 24,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 19.6875,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 15.375,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 11.0625,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 6.75,
    opacity: 0.05,
    r: 1.875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.25,
    cy: 2.4375,
    opacity: 0.03,
    r: 1.6875
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 45.5625,
    opacity: 0.03,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 41.25,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 36.9375,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 32.625,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 28.3125,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 24,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 19.6875,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 15.375,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 11.0625,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 6.75,
    opacity: 0.05,
    r: 1.6875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.8438,
    cy: 2.4375,
    opacity: 0.03,
    r: 1.6875
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 45.5625,
    opacity: 0.03,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 41.25,
    opacity: 0.07,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 36.9375,
    opacity: 0.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 32.625,
    opacity: 0.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 28.3125,
    opacity: 0.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 24,
    opacity: 0.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 19.6875,
    opacity: 0.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 15.375,
    opacity: 0.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 11.0625,
    opacity: 0.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 6.75,
    opacity: 0.05,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5312,
    cy: 2.4375,
    opacity: 0.03,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 45.5625,
    opacity: 0.03,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 41.25,
    opacity: 0.05,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 36.9375,
    opacity: 0.85,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 32.625,
    opacity: 0.85,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 28.3125,
    opacity: 0.85,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 24,
    opacity: 0.85,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 19.6875,
    opacity: 0.85,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 15.375,
    opacity: 0.85,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 11.0625,
    opacity: 0.85,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 6.75,
    opacity: 0.05,
    r: 1.40625
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3125,
    cy: 2.4375,
    opacity: 0.03,
    r: 1.40625
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 45.5625,
    opacity: 0.03,
    r: 1.21875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 41.25,
    opacity: 0.05,
    r: 1.21875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 36.9375,
    opacity: 0.8,
    r: 1.21875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 32.625,
    opacity: 0.8,
    r: 1.21875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 28.3125,
    opacity: 0.8,
    r: 1.21875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 24,
    opacity: 0.8,
    r: 1.21875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 19.6875,
    opacity: 0.8,
    r: 1.21875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.375,
    opacity: 0.8,
    r: 1.21875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 11.0625,
    opacity: 0.8,
    r: 1.21875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 6.75,
    opacity: 0.05,
    r: 1.21875
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 2.4375,
    opacity: 0.03,
    r: 1.21875
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 45.5625,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 41.25,
    opacity: 0.05,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 36.9375,
    opacity: 0.7,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 32.625,
    opacity: 0.7,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 28.3125,
    opacity: 0.7,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 24,
    opacity: 0.7,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 19.6875,
    opacity: 0.7,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 15.375,
    opacity: 0.7,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 11.0625,
    opacity: 0.7,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 6.75,
    opacity: 0.05,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.0625,
    cy: 2.4375,
    opacity: 0.03,
    r: 1.03125
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 45.5625,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 41.25,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 36.9375,
    opacity: 0.05,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 32.625,
    opacity: 0.05,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 28.3125,
    opacity: 0.05,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 24,
    opacity: 0.05,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 19.6875,
    opacity: 0.05,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 15.375,
    opacity: 0.05,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 11.0625,
    opacity: 0.05,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 6.75,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 2.4375,
    opacity: 0.03,
    r: 1.03125
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.4375,
    cy: 41.25,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4375,
    cy: 36.9375,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4375,
    cy: 32.625,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4375,
    cy: 28.3125,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4375,
    cy: 24,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4375,
    cy: 19.6875,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4375,
    cy: 15.375,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4375,
    cy: 11.0625,
    opacity: 0.03,
    r: 1.03125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4375,
    cy: 6.75,
    opacity: 0.03,
    r: 1.03125
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadlink);
export default __webpack_public_path__ + "static/media/broadlink.b8e0ffcc5e69d354a38fbbf0adaff632.svg";
export { ForwardRef as ReactComponent };